import { Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import Input from "../../../../../components/common/inputs/Input";
import Select from "../../../../../components/common/inputs/Select";
import Button from "../../../../../components/common/button/Button";
import { variationOptionsColumns } from "../../../../../constant/tables-columns/tablesColums";
import Table from "../../../../../components/common/table/Table";
import ImagesModal from "../../../../../components/common/modals/imgaes-modal/ImagesModal";
import { publicImageProps } from "../../../../../services/config";
import CurrencyInput from "../../../../../components/common/inputs/CurrencyInput";
import { warningMessage } from "../../../../../utils/toastify-message/ToastifyMessage";
import { productOptionsValidation } from "../../../../../utils/validation/prodcut/productOptionsValidation";
import DateInput from "../../../../../components/common/inputs/DateInput";
import { convertDate } from "../../../../../utils/convertDate";

const { forwardRef, useRef, useImperativeHandle } = React;

const ProductOption = forwardRef(({ optionData, handleOption }, ref) => {
  const [showModal, setShowModal] = useState(false);
  const [discountExpireDate, setDiscountExpireDate] = useState(
    optionData?.discountExpireDate
  );

  useImperativeHandle(ref, () => ({
    showModal() {
      setShowModal(!showModal);
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    afterSubmit() {
      setVariation(null);
      setName("");
      setDiscountType("price");
      setVariations([]);
      setImage("");
    },
  }));

  const [variation, setVariation] = useState(null);
  const [name, setName] = useState("");
  const [discountType, setDiscountType] = useState("price");
  const [variations, setVariations] = useState([]);

  const formHandler = async (values, { resetForm }) => {
    values["image"] = image || "";
    values["discountType"] = discountType;
    values["discount"] = Number(values.discount) || 0;
    values["discountExpireDate"] = discountExpireDate;
    values["price"] = Number(values.price) || 0;
    values["stock"] = Number(values.stock) || 0;
    values["limitStock"] = Number(values.limitStock) || 0;
    values["buyPrice"] = Number(values.buyPrice) || 0;
    if (!values?._id) {
      delete values["_id"];
    }

    if (
      discountType !== "percent" ||
      (discountType == "percent" && values.discount <= 100)
    ) {
      if (!variation) {
        setVariations((prevState) => [...prevState, values]);
        reset();
      } else {
        const newVariations = variations.filter(
          (item) => item.value != variation.value
        );
        setVariations([...newVariations, values]);
        setVariation(null);
        reset();
      }
      setImage("");
      setDiscountType("price");
      resetForm();
    } else {
      warningMessage("درصد تخفیف نمیتواند بیشتر از 100 باشد");
    }
  };

  const onDelete = (data) => {
    const newOptions = variations.filter((item) => item.value != data.value);
    setVariations(newOptions);
  };
  const onEdit = (data) => {
    setVariation(data);
    setDiscountType(data.discountType);
    setImage(data.image);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleNewVariations = () => {
    if (name?.length && variations?.length) {
      // console.log(optionData.value);
      console.log(variations);
      handleOption({
        name: name,
        variations: variations,
      });
      setVariation(null);
      // setVariations([]);
      setImage("");
      setShowModal(false);
    } else if (!name?.length && !variations?.length) {
      setShowModal(false);
      handleOption(null);
    } else {
      warningMessage("لطفا نام یا ویژگی آپشن را وارد کنید.");
    }
  };
  useEffect(() => {
    if (optionData?.variations?.length > 0) {
      let newVariations = optionData?.variations.map((item) => {
        item["discount"] =
          item.discountType == "percent"
            ? item.discountPercent
            : item.discountPrice;
        return item;
      });

      setVariations(newVariations);
      setName(optionData?.name);
    } else {
      setVariations([]);
      setName("");
    }
  }, [optionData]);

  const imagesModal = useRef();
  const [image, setImage] = useState("");

  const selectedImages = (item) => {
    console.log(item);
    setImage(item.name);
  };
  console.log(image);

  console.log(variations);

  const discountRef = useRef();
  const priceRef = useRef();
  const buyPriceRef = useRef();

  const reset = () => {
    discountRef.current.afterSubmit();
    priceRef.current.afterSubmit();
    buyPriceRef.current.afterSubmit();
  };

  console.log(variations);

  return (
    <>
      <div
        className={`admin-edit-backdrop fixed top-0 right-0 w-full h-full transition-all z-30  ${
          !showModal && "hidden"
        }`}
      ></div>
      <div
        hidden={!showModal}
        role="dialog"
        aria-label="تنوع محصول"
        aria-modal="true"
        className={`admin-edit-drawer w-full h-full overflow-y-scroll  bg-white shadow-md z-40 rounded-3xl p-4 transition-all absolute top-0 -left-[120%] ${
          showModal && "!left-0 is-open"
        }`}
      >
        <div className="flex w-full items-center justify-between">
          <h4>مدیریت تنوع محصول</h4>
          <Button
            onClick={handleNewVariations}
            type="button"
            color="primary"
            text="بازگشت"
          />
        </div>
        <div className="flex flex-wrap gap-3 my-4">
          <input
            value={name}
            onChange={(e) => setName(e.target.value)}
            name="name"
            aria-label="نام گروه تنوع"
            placeholder="نام گروه تنوع؛ مثلاً رنگ یا اندازه"
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          />
        </div>

        <h4>{variation ? "ویرایش تنوع" : "افزودن تنوع جدید"}</h4>
        <Formik
          enableReinitialize
          initialValues={{
            inventoryStatus: variation?.inventoryStatus || "available",
            value: variation?.value || "",
            price: variation?.price || "",
            buyPrice: variation?.buyPrice || "",
            image: variation?.image || "",
            stock: variation?.stock || "",
            limitStock: variation?.limitStock || "",
            desc: variation?.desc || "",
            checkStock: variation?.checkStock || false,
            discount: variation?.discount || "",
            sku: variation?.sku || "",
            _id: variation?._id || "",
          }}
          validationSchema={productOptionsValidation}
          onSubmit={formHandler}
        >
          {(formik) => (
            <Form>
              <div className="grid gap-6 my-4 md:grid-cols-2">
                <Input
                  name={"value"}
                  placeholder="مقدار"
                  label="مقدار"
                  type="text"
                />
                <div>
                  <label
                    for="large-input"
                    className="backdrop-blur block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    قیمت
                  </label>
                  <CurrencyInput
                    placeholder="قیمت"
                    ref={priceRef}
                    name="price"
                    inputValue={formik.values["price"]}
                    onChange={(e) => formik.setFieldValue("price", e)}
                  />
                  {formik.errors.price && formik.touched.price ? (
                    <p className="text-sm my-4 text-red-500">
                      {formik.errors.price}
                    </p>
                  ) : null}
                </div>
                <div>
                  <label
                    for="large-input"
                    className="backdrop-blur block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    قیمت خرید
                  </label>
                  <CurrencyInput
                    placeholder="قیمت خرید"
                    ref={buyPriceRef}
                    name="buyPrice"
                    inputValue={formik.values["buyPrice"]}
                    onChange={(e) => formik.setFieldValue("buyPrice", e)}
                  />
                  {formik.errors.buyPrice && formik.touched.buyPrice ? (
                    <p className="text-sm my-4 text-red-500">
                      {formik.errors.buyPrice}
                    </p>
                  ) : null}
                </div>
                <div>
                  <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    نوع تخفیف
                  </label>
                  <select
                    value={discountType}
                    onChange={(e) => setDiscountType(e.target.value)}
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  >
                    <option value={"percent"}>درصد</option>
                    <option value={"price"}>قیمت</option>
                  </select>
                </div>

                <div>
                  <label
                    for="large-input"
                    className="backdrop-blur block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    تخفیف
                  </label>
                  <CurrencyInput
                    placeholder="تخفیف"
                    name="discount"
                    ref={discountRef}
                    inputValue={formik.values["discount"]}
                    onChange={(e) => formik.setFieldValue("discount", e)}
                  />
                  {formik.errors.discount && formik.touched.discount ? (
                    <p className="text-sm my-4 text-red-500">
                      {formik.errors.discount}
                    </p>
                  ) : null}
                </div>
                <DateInput
                  label={`مقدار فعلی تاریخ انقضا ${
                    discountExpireDate
                      ? convertDate(discountExpireDate)
                      : "ندارد"
                  }`}
                  onChange={setDiscountExpireDate}
                />
                <Select
                  name="inventoryStatus"
                  placeholder="موجودی"
                  label="موجودی"
                >
                  <option value={"available"}>موجود</option>
                  <option value={"unavailable"}>نا موجود</option>
                </Select>
                <Input
                  name="stock"
                  placeholder="موجودی انبار"
                  label="موجودی انبار"
                  type="text"
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                />
                <Input
                  name="limitStock"
                  placeholder="محدودیت"
                  label="محدودیت"
                  type="text"
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                />
                <Input
                  name={"desc"}
                  placeholder="توضیحات"
                  label="توضیحات"
                  type="text"
                />
                <Input
                  name={"sku"}
                  placeholder="شناسه یکتا"
                  label="شناسه یکتا"
                  type="text"
                />
                <Select
                  name="checkStock"
                  value={formik.values["checkStock"] ? "true" : "false"}
                  onChange={(e) => {
                    formik.setFieldValue(
                      "checkStock",
                      e.target.value === "true"
                    );
                  }}
                  placeholder="بررسی موجودی انبار"
                  label="بررسی موجودی انبار"
                >
                  <option value="true">بله</option>
                  <option value="false">خیر</option>
                </Select>
                <div className="">
                  <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    عکس
                  </label>
                  <div className="flex items-center justify-between">
                    <div className="flex gap-2">
                      {image && (
                        <img
                          {...publicImageProps(image, { variant: "thumb_" })}
                          className="w-16 h-16 rounded-lg"
                          alt=""
                        />
                      )}
                      {/* <p className="max-w-12 overflow-hidden">{image || ""}</p> */}
                    </div>
                    <div className="flex gap-2">
                      {image && (
                        <Button
                          type="button"
                          onClick={() => setImage("")}
                          text={"حذف"}
                          color={"danger"}
                        />
                      )}

                      <Button
                        type="button"
                        onClick={() => imagesModal.current.showModal()}
                        text={image ? "ویرایش" : "انتخاب"}
                        color={"success"}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="mt-2 flex flex-wrap gap-3">
                {variation && (
                  <Button
                    type="button"
                    onClick={() => setVariation(null)}
                    text={"بازگشت"}
                    color={"danger"}
                  />
                )}
                <Button
                  text={variation ? "ویرایش" : "افزون"}
                  color={"primary"}
                />
              </div>
            </Form>
          )}
        </Formik>

        <Table
          columns={variationOptionsColumns}
          rows={variations}
          onEdit={onEdit}
          onDelete={onDelete}
          // onCustomFunction={addVariations}
          // customFunctionName={"ویژگی"}
          notFoundMessage="شما هنوز هیچ ویژگی اضافه نکرده اید"
        />
      </div>

      <ImagesModal selectedImages={selectedImages} ref={imagesModal} />
    </>
  );
});
export default ProductOption;
